import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { ref, reactive, onMounted } from 'vue'
import DetailCard from '@/components/DetailCard'
import { customerCodeDetail } from '@/api/gucangSales/customerCenter'
import { customerPhaseEnum, arkCodeStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
const __default__ = { name: 'BaseMessage' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  id: {
    type: String
  }
},
  setup(__props) {

const props = __props
const columns = ref([
  { title: '子客户代码', dataIndex: 'arkCode' },
  {
    title: '客户阶段',
    dataIndex: 'stage',
    node: 'cos-select',
    attrs: {
      options: customerPhaseEnum
    }
  },
  { title: '子客户代码名称', dataIndex: 'arkAccount' },
  { title: '档次', dataIndex: 'level' },
  { title: '联系人', dataIndex: 'arkContactName' },
  { title: '成交金额（万）', dataIndex: 'amount' },
  { title: '手机号', dataIndex: 'arkContactMobile' },
  { title: '更新时间', dataIndex: 'updateTime' },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '创建时间', dataIndex: 'createTime' },
  {
    title: 'ark账号状态',
    dataIndex: 'status',
    node: 'cos-select',
    attrs: {
      options: arkCodeStatusEnum
    }
  }
])
const data = reactive({})
const fetch = () => {
  if (props.id) {
    customerCodeDetail(props.id).then((res) => {
      Object.assign(data, res.data)
    })
  }
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    name: "advanced_search"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DetailCard), {
        columns: columns.value,
        title: "基础信息",
        data: data
      }, null, 8, ["columns", "data"])
    ]),
    _: 1
  }, 512))
}
}

})